import React from "react";
import { Box, Grid2 as Grid, IconButton, SxProps, Tooltip } from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { ImageUploadProps } from "../../Types/allTypes";
import { Cancel } from "@mui/icons-material";

const ImageUpload: React.FC<ImageUploadProps> = ({
    imagePreviews,
    handleImageChange,
    handleRemoveImage,
    reviewUpload
}) => {

    const theme = useTheme();

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files) {
            handleImageChange(Array.from(files));
        }
    };

    const cameraButtonCSS = reviewUpload ? {
        width: 120,
        height: 90,
        overflow: 'hidden',
        cursor: 'pointer',
    } : {
        width: 100,
        height: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        aspectRatio: "1/1",
        border: '0.1em solid',
        borderRadius: 2,
        cursor: "pointer",
    };

    const imagePreviewCSS: SxProps = reviewUpload ? {
        width: 120,
        height: 90,
        border: '0.1em solid',
        borderRadius: '4px',
        overflow: 'hidden',
        cursor: 'pointer',
        '&:hover': {
            borderColor: theme.palette.primary.main,
        },
    } : {
        maxWidth: 100,
        maxHeight: 100,
        display: "flex",
        aspectRatio: "1/1",
        border: '0.1em solid',
        borderRadius: 2,
        overflow: "hidden",
        position: "relative",
    };

    const gridContainerCSS = reviewUpload ? { mb: 2 } : { 
        
        maxWidth: 400,
        maxHeight: 400,
        marginLeft: '1em',
        overflow: 'scroll',
    };

    return (
        <Grid container spacing={1} sx={gridContainerCSS}>
            <Grid>
                <Tooltip title="Upload Image">
                    <Box sx={cameraButtonCSS} component="label">
                        <PhotoCamera sx={{ fontSize: "4rem", border: 2, borderRadius: 2, p:2 }} />
                        <input
                            type="file"
                            accept="image/*"
                            hidden
                            multiple
                            onChange={handleFileChange}
                        />
                    </Box>
                </Tooltip>
            </Grid>
            {imagePreviews.map((imagePreviewUrl, index) => (
                <Grid key={index}>
                    <Box
                        sx={imagePreviewCSS}
                    >
                        <img
                            src={imagePreviewUrl}
                            alt={`Image Preview ${index + 1}`}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "fill",
                            }}
                        />
                        <IconButton
                            sx={{
                                position: "relative",
                                bottom: 105,
                                left: 80,
                                scale: .5,
                                // backgroundColor: theme.palette.background.default,
                                '&:hover': {
                                    color: 'error.main',
                                }
                            }}
                            onClick={() => handleRemoveImage(index)}
                        >
                            <Cancel fontSize="large"/>
                        </IconButton>
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
};

export default ImageUpload;
